import { useMutation } from "@tanstack/react-query"
import { toast } from "react-hot-toast"

import usePlanUpdateModalStore from "./usePlanUpdateModalStore"
import { QUERY_KEYS } from "../../../constants"
import { updateCoachSubscription } from "../../../networking/subscriptions"
import { queryClient } from "../../../util/queryClient"

const usePlanUpdateMutation = () => {
  const { onCloseConfirmationModal } = usePlanUpdateModalStore()

  return useMutation({
    mutationFn: updateCoachSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.SUBSCRIPTION_PACKAGES])
      queryClient.invalidateQueries([QUERY_KEYS.SESSION_BILLING_PERIODS])
      queryClient.invalidateQueries([QUERY_KEYS.COACH_SUBSCRIPTION])
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.[0] || error?.message)
      onCloseConfirmationModal()
    },
  })
}

export default usePlanUpdateMutation
